import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Main_page from '../views/Main_page'
import Basic_info from '../views/new_lease/Basic_info.vue'
import Commercial_terms from '../views/new_lease/Commercial_terms.vue'
import Security_instruments from '../views/new_lease/Security_instruments.vue'
import Ifrs_16 from '../views/new_lease/Ifrs_16.vue'
import Register from '../views/Register.vue' 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/main-page',
    name: 'main-page',
    component: Main_page
  },
  {
    path: '/basic-info',
    name: 'basic-info',
    component: Basic_info
  },
  {
    path: '/commercial-terms',
    name: 'commercial-terms',
    component: Commercial_terms
  },
  {
    path: '/security-instruments',
    name: 'security-instruments',
    component: Security_instruments
  },
  {
    path: '/ifrs-16',
    name: 'ifrs-16',
    component: Ifrs_16
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
